<template>
    <div class="product">
        <headers :title="product.title" :img="product.type"></headers>
        <el-row :gutter="20">
            <el-col :span="5" :offset="5"><div class="mainTitle">{{product.title}}</div></el-col>
            <el-col :xs="{span:6,offset:3}" :sm="{span:6,offset:3}" :md="{span:2,offset:7}" :lg="{span:2,offset:7}" :xl="{span:2,offset:7}"><div class="backBtn" @click="goBack()"><img src="../../public/img/whiteLeft.png" height="60%" alt="" srcset="">{{$t('返回上一级')}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="14" :offset="5"><div class="line"></div></el-col>
        </el-row>
        <el-row style="margin-bottom:5rem;">
            <el-col :span="14" :offset="5">
                <el-row :gutter="20">
                    <el-col @click.native="turnInfo(index)" :xs="12" :sm="8" :md="8" :lg="{span:6,offset:0}" :xl="{span:6,offset:0}" v-for="(item, index) in product.child" :key="index">
                        <productItem  :img="item.img" :text="item.name"></productItem>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <foot></foot>
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
import productItem from "@/components/productItem.vue";
import {productData} from "../datas/productData.js"
export default {
    created(){
        this.render()
    },
    data() {
        return {
            product:{
                title:'',
                type:'',
                child:[]
            }
        }
    },
    watch: {
        '$route' (to, from) {
            this.render()
        },
        '$i18n.locale'(){
            this.render()
        },
    },
    methods:{
        render(){
            // console.log(this.$route.params.class)
            this.product = this.productList(this.$route.params.class,this.$route.params.index)
        },
        turnInfo(index){
            this.$root.$router.push({path:`/productInfo/${this.$route.params.class}/${this.$route.params.index}/${index}`})
        },
        productList(className,index){
            return productData(className).itemList[index]
        },
        goBack(){
            this.$root.$router.go(-1)
        }
    },
    components:{
        headers,foot,productItem
    }
}
</script>
<style lang="less">
.product{
    .mainTitle{
        font-size: 1.5rem;
        margin-top: 3rem;
        color: #444444;
        font-weight: bold;
        white-space:nowrap;
        margin-bottom: 1.5rem;
        
    }
    .line{
        border-bottom: 1px solid #444444;
        margin-bottom: 1.5rem;
    }
    .backBtn{
        background-color: rgba(1, 124, 168, 0.31);
        font-size: 0.6rem;
        line-height: 1.4rem;
        height: 1.4rem;
        font-weight: 1;
        cursor: pointer;
        border-radius: 1rem;
        img{
            margin-right: 0.3rem;
            flex-grow: 0;
            height: 40%;
            flex-shrink: 0;
            // height: 50%;
        }
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 3.4rem;
        color: #ffffff;
        white-space:nowrap;
        margin-bottom: 1.5rem;
    }
}
</style>
